module.exports = __webpack_public_path__ + "static/media/17-iveco.4d2288fb.jpg";